var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSignUpGoogle32 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  fillRule: "evenodd",
  d: "M27.52 16.272c0-.85-.076-1.669-.218-2.454H16v4.642h6.458a5.52 5.52 0 0 1-2.394 3.621v3.011h3.878c2.269-2.089 3.578-5.165 3.578-8.82",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  fillRule: "evenodd",
  d: "M16 28c3.24 0 5.956-1.075 7.942-2.907l-3.878-3.011c-1.075.72-2.45 1.145-4.064 1.145-3.125 0-5.77-2.11-6.715-4.947H5.276v3.109A12 12 0 0 0 16 27.999",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  fillRule: "evenodd",
  d: "M9.285 18.28A7.2 7.2 0 0 1 8.91 16c0-.79.136-1.56.376-2.28v-3.109H5.276A12 12 0 0 0 4 16.001c0 1.935.464 3.768 1.276 5.388z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  fillRule: "evenodd",
  d: "M16 8.773c1.762 0 3.344.605 4.587 1.794l3.442-3.442C21.951 5.19 19.235 4 16 4c-4.69 0-8.75 2.69-10.724 6.61l4.01 3.11c.943-2.836 3.589-4.947 6.714-4.947",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignUpGoogle32);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };